import ArrowDown from '../../src/legacy/ArrowDown';
export default ArrowDown;
